import GoogleMapComponent from './GoogleMap';

export default function MapSection({ pickupPlaceId, dropPlaceId, additionalDirectionData, setAdditionalDirectionData }) {
  console.log('map Section', {
    pickupPlaceId,
    dropPlaceId,
  });

  return <GoogleMapComponent pickupPlaceId={pickupPlaceId} dropPlaceId={dropPlaceId} setAdditionalDirectionData={setAdditionalDirectionData} />;
}
